import React, { Component } from "react";
import { withStyles, Grid, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import NavBar from "./Navbar/NavBar";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import {
  viewModeRoutes,
  topRoutes,
  bottomRoutes,
} from "./Routes/ProjectRoutes";
import FlagNotification from "../Header/notificationBar";
import DashboardLocked from "./DashboardLocked";
import clsx from "clsx";
import Preloader from "../../static/preloader.gif";
import { TENANT_ID, metaAdsPageAccess } from "../../config/config";

class ProjectsLayout extends Component {
  state = {
    status: "",
    statusMessage: "",
  };

  planRenewNotify = () => {
    const { partner } = this.props;
    const { partnershipRenewalOn } = partner;
    let partnershipRenewal = new Date(partnershipRenewalOn);
    let today = new Date();

    let differenceInTime = partnershipRenewal.getTime() - today.getTime();
    let differenceInDays = differenceInTime / (1000 * 3600 * 24);

    const daysUntilRenewal = Math.floor(differenceInDays);
    return daysUntilRenewal;
  };

  render() {
    const { classes, location, agent, partner, isPartnerDetailLoading } =
      this.props;
    if (
      !isPartnerDetailLoading &&
      partner?.partnershipStatus === "stopped"
    ) {
      return <DashboardLocked remark={partner.partnershipStatusRemark} />;
    }
    const {
      type,
      partnershipFee,
      currency,
      partnershipRenewalOn,
      centralBalance,
      minAllowedBalance,
      addons = {},
    } = partner || {};
    const pathname = location.pathname;
    const routes = agent.isReferral ? viewModeRoutes : topRoutes;
    const fee = partnershipFee / 100000 || 0;

    let totalAddonFee = 0;
    if (Object.keys(addons).length > 0) {
      totalAddonFee = Object.values(addons).reduce((total, addon) => {
        if (addon.aisensyPrice[currency]) {
          return total + addon.aisensyPrice[currency];
        }
        return total;
      }, 0);
    }
    const totalFee = fee + totalAddonFee / 100000 || 0;
    const daysUntilRenewal = this.planRenewNotify();
    const symbol = currency === "USD" ? "$" : "₹";
    const date = new Date(partnershipRenewalOn)?.toLocaleDateString();
    const negetiveBalance = centralBalance < (minAllowedBalance || 0);
    const lowBalance =
      currency === "USD"
        ? centralBalance / 100000 < 48
        : centralBalance / 100000 < 3000;

    const isTenant = TENANT_ID === partner._id;

    const filteredRoutes = routes.filter((route, index) => {
      if (route.to === "/meta-ads") {
        return metaAdsPageAccess.includes(
          this.props.partner?._id || this.props.partner?.id || ""
        );
      }
      return true;
    });

    const hasNotifications =
      (!isTenant &&
        !isPartnerDetailLoading &&
        ((daysUntilRenewal <= 10 && daysUntilRenewal > 0 && totalFee !== 0) ||
          (daysUntilRenewal === 0 && totalFee !== 0) ||
          negetiveBalance ||
          lowBalance)) ||
      (!isPartnerDetailLoading &&
        (TENANT_ID || partner._id !== "65b268d4510ef90bbdc3c726"));

    return (
      <div id="projects-layout" className={classes.root}>
        {isTenant || isPartnerDetailLoading ? null : daysUntilRenewal <= 10 &&
          daysUntilRenewal > 0 &&
          totalFee !== 0 ? (
          <FlagNotification
            message={`Your plan renewal is in ${daysUntilRenewal} days. ${symbol}${totalFee} will be automatically deducted from your central balance on ${date}`}
            icon={"warning"}
            color="#FAB038"
            textColor="#000"
          />
        ) : daysUntilRenewal === 0 && totalFee !== 0 ? (
          <FlagNotification
            message={`Your plan renewal date is today! ${symbol}${totalFee} will be automatically deducted from your central balance.`}
            icon={"warning"}
            color="#FAB038"
            textColor="#000"
          />
        ) : negetiveBalance ? (
          <FlagNotification
            message={`Your services have been temporarily suspended due to insufficient central balance.`}
            icon={"error"}
            color="#FF1F1F"
            textColor="#FFFFFF"
          />
        ) : lowBalance ? (
          <FlagNotification
            message={`You are low on central balance. Please recharge your account to avoid service suspension.`}
            icon={"error"}
            color="#FF4747"
            textColor="#FFFFFF"
          />
        ) : null}

        {isPartnerDetailLoading ? null : TENANT_ID ? (
          <FlagNotification
            message={`Attention: Service conversations are free now, effective from November 1, 2024.`}
            icon={"info"}
            color="#429f47"
            textColor="#dff0d8"
          />
        ) : partner._id !== "65b268d4510ef90bbdc3c726" ? (
          <FlagNotification
            message={
              <p>
                <span
                  style={{ fontWeight: 600, color: "#000", fontSize: "14px" }}
                >
                  Support Email
                </span>
                :{" "}
                <span style={{ fontWeight: 600, color: "#0966c2" }}>
                  partnership.support@aisensy.com
                </span>{" "}
                |{" "}
                <span
                  style={{ fontWeight: 600, color: "#000", fontSize: "14px" }}
                >
                  Invoice/Payment related queries:
                </span>{" "}
                <span style={{ fontWeight: 600, color: "#0966c2" }}>
                  partnership-invoice@aisensy.com
                </span>{" "}
                (CC AiSensy team).
              </p>
            }
            icon={"info"}
            color="#C5EDCF"
            textColor="#404040"
            tooltipTitle={
              <p>
                <span
                  style={{ fontWeight: 600, color: "#000", fontSize: "12px" }}
                >
                  Hi There!
                </span>
                <br />
                <br />
                <span style={{ color: "#000", fontSize: "12px" }}>
                  We've moved to a dedicated help-desk for faster and more
                  efficient support! 🚀
                </span>
                <br />
                <br />
                <span style={{ color: "#000", fontSize: "12px" }}>
                  For assistance, email partnership.support@aisensy.com to
                  create a ticket. 🎟️ Then, share the ticket ID with us on
                  WhatsApp for quicker tracking and resolution. ✅📲
                </span>
                <br />
                <br />
                <span style={{ color: "#000", fontSize: "12px" }}>
                  We appreciate your cooperation in enhancing your support
                  experience! 😊 We look forward to assisting you! 🚀
                </span>
              </p>
            }
          />
        ) : null}

        <NavBar hasNotifications={hasNotifications} />

        <ErrorBoundary>
          <div id="route-container" className={classes.routeContainer}>
            <Switch>
              {filteredRoutes.map((route, index) => {
                if (!route.excludedTypes?.includes(type)) {
                  return (
                    <Route
                      exact={route.exact}
                      key={route.name}
                      path={route.to}
                      component={route.component}
                    />
                  );
                }
              })}
              {bottomRoutes.map((route) => {
                return (
                  <Route
                    exact
                    key={route.name}
                    path={route.to}
                    component={route.component}
                  />
                );
              })}
              <Route component={() => <Redirect to="/error" />} />
            </Switch>
          </div>
        </ErrorBoundary>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      overflowY: "auto",
      position: "relative",
    },
  },
  routeContainer: {
    width: "calc(100% - 70px)",
    height: "100vh",
    transition: "1s",
    overflow: "hidden",
    marginLeft: 70,
    // background: "green",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "calc(100vh - 50px)",
      // height: "100vh",
      marginLeft: 0,
    },
  },
  fullHeight: {
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
    },
  },
  preloader: {
    height: 150,
  },
});

const connectedProjectslayout = connect((state) => ({
  agent: state.login.user,
  partner: state.partner.partner,
  isPartnerDetailLoading: state.partner.isLoading,
  tenantDetails: state.tenant.tenant,
}))(ProjectsLayout);

export default withStyles(styles)(connectedProjectslayout);
